import {SSLA} from "./app";
import {VERSION} from "./version";
import {ScormAllVersionsPlugin} from "./scormallversions/plugin";

export function start(config: {}) {
    if (config) {
        ssla.setConfigurationSource(config);
    }
    ssla.start();
}

export function init() {
    ssla = new SSLA();
    let scormPlugin = new ScormAllVersionsPlugin();
    ssla.registerPlugin("scorm", scormPlugin);
}

export function cleanup() {
    ssla.cleanup();
}

export function closeActiveContent() {
    ssla.closeActiveContent();
}

export function interstitialReady() {
    ssla.interstitialReady();
}

export function navigate(type: string) {
    ssla.navigate(type);
}

export function navigateByIdentifier(id: string) {
    ssla.navigateByIdentifier(id);
}

export function finish() {
    ssla.finish();
}

export let ssla: SSLA = null;
export let version = VERSION;
init();